const getCookieDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};

const FOURTEEN_DAYS_IN_SECONDS = 14 * 24 * 60 * 60;

export const ensureClientBucketCookie = () => {
  if (document.cookie.includes('clientBucket=')) {
    return;
  }

  // see https://github.schibsted.io/smp-distribution/edge/blob/08f2c1a0eb3f7a33c3d44970c00a5ec351f87d1f/vg/conf.d/sites/vg_no.vcl#L41
  const value = Math.floor(Math.random() * 100); // 0-99

  // same as in VCL https://github.schibsted.io/smp-distribution/edge/blob/08f2c1a0eb3f7a33c3d44970c00a5ec351f87d1f/vg/conf.d/sites/vg_no.vcl#L1265-L1267
  document.cookie = `clientBucket=${value}; Max-Age=${FOURTEEN_DAYS_IN_SECONDS}; Domain=${getCookieDomain()}; Path=/; Secure; SameSite=Strict`;
};
